import { GlobalEnumsAceBenutzerrolle } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-benutzerrolle";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Token } from "./abstractions/token.model";

export class IdToken implements Token<string> {
    protected jwtHelper = new JwtHelperService();

    public issuer: string;
    public audience: string[];
    public expiresAt: Date;
    public issuedAt: Date;
    public subject: string;
    public get username(): string {
        return this.subject;
    }
    public get email(): string {
        return this.subject;
    }
    public firstname: string;
    public lastname: string;
    public benutzerrolle: GlobalEnumsAceBenutzerrolle;
    public get fullname(): string {
        let names: string[] = [];

        if (this.firstname)
            names.push(this.firstname);

        if (this.lastname)
            names.push(this.lastname);

        return names.join(" ");
    }

    public get isExpired(): boolean {
        return this.jwtHelper.isTokenExpired(this.token);
    }

    public get type(): string {
        return IdToken.name;
    }


    constructor(protected token: string) {
        if (!token)
            return;

        let decodedToken: any = this.jwtHelper.decodeToken(token);

        if (!decodedToken.iss)
            throw new Error("issuer can't be empty");

        if (!decodedToken.aud)
            throw new Error("audience can't be empty");

        if (!decodedToken.exp)
            throw new Error("expires at can't be empty");

        if (!decodedToken.iat)
            throw new Error("issued at can't be empty");

        if (!decodedToken.sub)
            throw new Error("subject can't be empty");

        if (!decodedToken.benutzerrolle)
            throw new Error("benutzerrolle can't be empty");

        this.issuer = decodedToken.iss;
        this.audience = decodedToken.aud;
        this.expiresAt = decodedToken.exp;
        this.issuedAt = decodedToken.iat;
        this.subject = decodedToken.sub;
        this.firstname = decodedToken.firstname;
        this.lastname = decodedToken.lastname;
        this.benutzerrolle = decodedToken.benutzerrolle;
    }

    public toJwtToken(): string {
        return this.token;
    }
}